import { useLocation } from "react-router-dom";
import { NAV_ITEMS } from "@/components/navConfig";
import { Construction } from "lucide-react";

export default function Placeholder() {
  const { pathname } = useLocation();
  const item = NAV_ITEMS.find((n) => n.path === pathname);
  const Icon = item?.icon || Construction;

  return (
    <div className="space-y-6" data-testid={`placeholder-${item?.key || "module"}`}>
      <div>
        <h1 className="text-2xl lg:text-3xl font-extrabold tracking-tight text-brand-graphite">
          {item?.label}
        </h1>
        <p className="text-brand-gray/70 mt-1 text-sm">
          Módulo en construcción — disponible en un próximo sprint.
        </p>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-16 flex flex-col items-center justify-center text-center">
        <div className="h-16 w-16 rounded-xl bg-brand-light flex items-center justify-center mb-5">
          <Icon className="h-8 w-8 text-brand-graphite" strokeWidth={1.75} />
        </div>
        <h2 className="text-lg font-bold text-brand-graphite">{item?.label}</h2>
        <p className="text-sm text-brand-gray/60 mt-2 max-w-sm">
          Esta sección forma parte del roadmap de MyFriendRent. En el Sprint 1 solo el
          Panel está operativo.
        </p>
        <span className="mt-6 inline-flex items-center px-3 py-1 rounded-full bg-brand-yellow text-brand-graphite text-xs font-bold">
          Próximamente
        </span>
      </div>
    </div>
  );
}
